const normalizeRetailRouteSegment = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const resolveRetailModulePath = (module, user, posId) => {
  if (!module.useRetailAlias) return module.path;

  const alias =
    user?.mobileAlias ||
    user?.pos?.mobileAlias ||
    user?.store?.mobileAlias ||
    user?.storeName ||
    user?.companyname ||
    posId ||
    user?.posId ||
    "";
  const routeSegment = normalizeRetailRouteSegment(alias);
  return routeSegment ? `${module.path}/${routeSegment}` : module.path;
};
